import React from 'react';
import ReactDOM from 'react-dom/client';
// antd v5 static APIs (Modal.confirm, message.*, notification.*) render
// through react-dom's removed legacy entry points under React 19 and
// silently no-op — the invoice "Send to client" confirm was the first
// flow to surface it. This official patch reroutes them through
// createRoot; it must import before any component module pulls in antd.
import '@ant-design/v5-patch-for-react-19';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import GlobalStyles from './utils/GlobalStyles';
import { pdfjs } from 'react-pdf';
import { addNotification } from './slice/SnackbarSlice';
import { installStaleChunkReload } from './utils/staleChunkReload';

// Must install before anything lazy-loads: recovers tabs that straddle
// a deploy instead of stranding them on a dead chunk reference.
installStaleChunkReload();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
  release: process.env.REACT_APP_SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf-worker/pdf.worker.min.js`;

// Disable React error overlay in development
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string') {
      const message = args[0];

      // Catch worker "File type not supported" here
      if (message.includes('File type not supported')) {
        // originalError.apply(console, args);
        // Show snackbar
        console.log("Caught here:", args);
         store.dispatch(
          addNotification({
            id: Date.now().toString(),
            newMsg: 'Failed to insert file: File type not supported',
            success: false,
          })
        );
        // return; // prevent duplicate logging below
      }

      if (message.includes('Uncaught') || message.includes('Unhandled')) {
        originalError.apply(console, args);
        return;
      }
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <GlobalStyles />
      <App />
    </Provider>
  // </React.StrictMode>
);

reportWebVitals();
